import { createContext, useState, ReactNode } from "react";
import { BrandResult } from "~src/sections/competitorAnalytics/SearchBar";

type BrandComparisonContextType = {
  selectedBrands: BrandResult[];
  setSelectedBrands: React.Dispatch<React.SetStateAction<BrandResult[]>>;
};

const BrandComparisonContext = createContext<BrandComparisonContextType | null>(
  null,
);

const BrandComparisonProvider = ({ children }: { children: ReactNode }) => {
  const [selectedBrands, setSelectedBrands] = useState<BrandResult[]>([]);

  const contextValue = {
    selectedBrands,
    setSelectedBrands,
  };

  return (
    <BrandComparisonContext.Provider value={contextValue}>
      {children}
    </BrandComparisonContext.Provider>
  );
};

export { BrandComparisonContext, BrandComparisonProvider };
